import { Button, Tooltip } from "@mui/material"
import { useAlerts, useMountEffect } from "@sis/react-library";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import { loadProviders } from "../../../redux/common/commonActions";
import { commonState } from "../../../redux/common/commonSlice";
import { useEffect } from "react";
import { loadTracks } from "../../../redux/track/trackAction";

interface AdminFunctionsResaveAllTracksButtonProps {
    busy: boolean;
    onClick: () => void;
}

export const AdminFunctionsResaveAllTracksButton = ({
    busy, onClick
}: AdminFunctionsResaveAllTracksButtonProps) => {

    const common = useAppSelector(commonState);
    const dispatch = useAppDispatch();

    const loadAllTracks = async () => {
        for (const provider of common.providers) {
            await dispatch(loadTracks(provider.code));
        }
    }

    useMountEffect(() => {
        dispatch(loadProviders());
    })

    useEffect(() => {
        loadAllTracks();
        // We want to restrict only on providers
        // eslint-disable-next-line        
    }, [common.providers])

    const { confirm } = useAlerts();

    const handleOnClick = () => {
        confirm("Resave all tracks", "Are you sure you want to resave all tracks?",
            () => { onClick() },
            "Yes", "No"
        )
    }

    return (
        <Tooltip title="Resaves all tracks with their current configuration." arrow>
            <Button
                id='resave-all-tracks'
                variant="contained"
                disabled={busy}
                onClick={handleOnClick}
            >
                Resave all tracks
            </Button>
        </Tooltip>
    )
}
